if (!customElements.get('custom-storefront-api-client')) {
    customElements.define(
        'custom-storefront-api-client',
        class CustomStorefrontApiClient {
            constructor() {
                this.scriptSrc = "https://unpkg.com/@shopify/storefront-api-client@0.2.3/dist/umd/storefront-api-client.min.js";
                this.client = null;
                this.retryDelays = [1000, 2000, 5000];
                this.init();
            }

            init() {
                const script = this.loadScript();

                if (window.ShopifyStorefrontAPIClient && window.ShopifyStorefrontAPIClient.createStorefrontApiClient) {
                    // Script already loaded
                    this.createClient();
                } else {
                    // Wait for the injected script to load
                    script.addEventListener('load', () => this.createClient(), { once: true });
                    script.addEventListener('error', () => {
                        console.error('Failed to load Shopify Storefront API client');
                    }, { once: true });
                }
            }

            loadScript() {
                let script = document.querySelector(`script[src="${this.scriptSrc}"]`);
                if (!script) {
                    script = document.createElement('script');
                    script.src = this.scriptSrc;
                    document.body.appendChild(script);
                }
                return script;
            }

            createClient() {
                if (
                    !window.ShopifyStorefrontAPIClient ||
                    !window.ShopifyStorefrontAPIClient.createStorefrontApiClient
                ) {
                    console.error('ShopifyStorefrontAPIClient is not available on window');
                    return;
                }

                const env = window.location.protocol === 'http:' 
                    || window.location.href.includes('deltastar-test') 
                    || window.location.href.includes('deltastar-dev') 
                    || window.location.href.includes('test.deltastar.nl') 
                    ? 'test' : 'prod';
                const params = {
                    test: {
                        storeDomain: 'https://deltastar-test.myshopify.com/',
                        apiVersion: '2025-10',
                        publicAccessToken: '451c101420e64abe1982f2c33b1f1936',
                    },
                    prod: {
                        storeDomain: 'https://deltastar-development.myshopify.com/',
                        apiVersion: '2025-10',
                        publicAccessToken: '3475f71f1d083e920a9c9e6edb1f4cda',
                    }
                };

                this.client = window.ShopifyStorefrontAPIClient.createStorefrontApiClient(params[env]);
            }

            async getClient() {
                if (this.client) {
                    return this.client;
                }

                for (const delay of this.retryDelays) {
                    await this.delay(delay);

                    if (this.client) {
                        return this.client;
                    }
                }

                console.error('Failed to initialize Shopify Storefront API client after retries');
                return null;
            }

            delay(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }
        }
    )
}